import { useEffect, useImperativeHandle } from 'react';

import { Stack } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TextArea } from '~components';
import { useFormContainer } from '~hooks';
import Device from '~interfaces/device';

import Dimens from '../../../../themes/dimens';

interface EditFormData {
	description: string;
}

interface EditDeviceFormProps {
	initialDevice: Device;
	onSubmit: (value: Device) => void;
	onCancel: () => void;
}

const EditDeviceForm = ({ initialDevice, onSubmit, onCancel }: EditDeviceFormProps) => {
	const { setDisabled, formRef } = useFormContainer();

	const { getValues, control, formState } = useForm<EditFormData>({
		defaultValues: {
			description: (initialDevice.description ?? '').trim(),
		},
		mode: 'onChange',
	});

	const { t } = useTranslation('entities');

	useImperativeHandle(
		formRef,
		() => ({
			onSubmit: () => onSubmit?.({ ...initialDevice, description: getValues().description }),
			onCancel: () => onCancel?.(),
		}),
		[onSubmit, onCancel, getValues, initialDevice]
	);

	useEffect(() => {
		setDisabled?.(!formState.isValid);
	}, [formState.isValid, setDisabled]);

	return (
		<Stack spacing={Dimens.spacingMd}>
			<Controller
				name='description'
				control={control}
				render={({ field }) => (
					<TextArea
						{...field}
						label={t('device.fields.description')}
						value={field.value}
						placeholder={t('general.enterDescriptionPlaceholder')}
					/>
				)}
			/>
		</Stack>
	);
};

export default EditDeviceForm;
